import { RegisterForm } from '@/features/auth';
import { setPageTitle } from '@/lib/utils';

export function RegisterPage() {
  setPageTitle('Register');
  return <RegisterForm />;
}
